import { useOldMU } from "@/constants/constants";
import Checkout from "@/redux/models/Checkout";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";
import { ConfirmationModal } from "../ConfirmationModal";
import { useState } from "react";

export const ReorderButton = ({ design }) => {
  const dispatch = useDispatch();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const router = useRouter();

  const handleReorderDesign = (withHC = false) => {
    dispatch(
      Checkout.types.initCheckoutDesignReorder({
        id: design.id,
        add_hc: withHC,
        cb: (orderId, designId) => {
          if (useOldMU) router.push(`/create/${orderId}/${designId}/details`);
          else router.push(`/custom-shape-car-air-fresheners/${orderId}/${designId}/details`);
        },
      })
    );
  };

  return (
    <>
      <button
        type="button"
        className="blue-button px-2 cursor-pointer whitespace-nowrap text-sm"
        onClick={() => {
          if (design.hcard_design) {
            setIsConfirmOpen(true);
          } else {
            handleReorderDesign();
          }
        }}
      >
        Re-order
      </button>
      <ConfirmationModal
        title="This design has a retail card"
        text="Do you want to reorder with the retail card?"
        isOpened={isConfirmOpen}
        onCancel={() => {
          setIsConfirmOpen(false);
          handleReorderDesign();
        }}
        onConfirm={() => {
          setIsConfirmOpen(false);
          handleReorderDesign(true);
        }}
        confirmLabel="Freshener + Retail Card"
        cancelLabel="Freshener Only"
        size="md"
      />
    </>
  );
};
